import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { hasAnyPermission } from '../auth/auth-permissions.util';
import { AuthActions, authFeature } from '../../features/auth/state';
import { AuthSessionSyncService } from '../services/auth-session-sync.service';

/**
 * Route guard for actions that must be protected by an explicit permission.
 * Unlike roleGuard, administrative and root roles do not bypass this check.
 */
export const permissionGuard: CanActivateFn = (route) => {
  const store = inject(Store);
  const router = inject(Router);
  const sessionSync = inject(AuthSessionSyncService);
  const requiredPermissions = (route.data?.['permissions'] ?? []) as string[];

  if (!requiredPermissions.length) return true;

  const permissions = store.selectSignal(authFeature.selectPermissions);
  const roles = store.selectSignal(authFeature.selectRoles);
  const legacyRole = store.selectSignal(authFeature.selectRole);
  const session = sessionSync.readSession();

  if (!legacyRole() && !roles().length && session.token) {
    store.dispatch(AuthActions.initSuccess(session));
  }

  const activePermissions = permissions().length ? permissions() : session.permissions;
  if (hasAnyPermission(activePermissions, requiredPermissions)) return true;

  return router.createUrlTree(['/access-denied'], {
    queryParams: { required: requiredPermissions.join(',') },
  });
};
